import { styled as r } from "styled-components";
import { rotationKeyframes as e } from "../../styles/animation.js";
import { Colors as i } from "../../styles/colors/index.js";
import { Theme as t } from "../../styles/themes/index.js";
const l = r.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`, s = r.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  position: relative;

  background: linear-gradient(
    to bottom,
    rgb(${t.colors.Brand}) 0%,
    rgba(255, 255, 255, 0) 90%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: ${e} 0.7s linear infinite;

  &:before {
    content: '';
    display: block;
    width: 15px;
    height: 15px;
    background: rgb(${({ background: o }) => o || t.colors.Juliet});
    position: absolute;
    bottom: 5px;
    right: -2px;
    transform: rotate(-12deg);
  }

  &:after {
    position: absolute;
    content: '';
    display: block;
    top: 4px;
    left: 4px;
    width: 28px;
    height: 28px;
    background-color: rgb(
      ${({ background: o }) => o || t.colors.Juliet}
    );
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50%;
    overflow: hidden;
  }
`, c = r.span`
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.2em;
  color: rgb(${i.Gray});
`;
export {
  l as LoadingContainer,
  s as LoadingIcon,
  c as LoadingText
};
